angular.module("vgresiduos").controller("UserPermissionsCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/usuarios/${$stateParams.id}/permissoes`);
		};
	}
]);
